import apiService from "../../api/api.service";
import { FollowedStoresResponse, GetFollowedStoresRequest } from "./followed-stores.types";

/**
 * Get customer's followed stores with products
 */
export const fetchFollowedStores = (params?: GetFollowedStoresRequest) => {
  return apiService.get<FollowedStoresResponse>("/customers/followed-sellers-products", { params });
};
